import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { TooltipModule } from "../../../common/utils/tooltips/tooltip.module";
import { UserActionDirectivesModule } from "../../../common/utils/user-action-directives/user-action-directives.module";
import { ButtonComponent } from "./button.component";

@NgModule({
  imports: [CommonModule, UserActionDirectivesModule, TooltipModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent]
})
export class ButtonComponentModule {}
